import { RouteType } from "types/RouteType";
import agentChatRoute from "./AgentChat/agentChat.Route";
import agentAdminRoute from "./AgentAdmin/agentAdmin.Route";

/**
 * AI Agent module routes.
 *
 * Two routes: the Rosie chat (staff) and Agent Admin (admin-only). Both live in
 * the existing "AI" nav group beside
 * LLM Providers / Task Routing / Usage — the agent is a consumer of that same
 * control plane (its spend is logged as the `agent.chat` task), so a separate
 * group would misfile it.
 */
const aiAgentRoutesList: RouteType[] = [...agentChatRoute, ...agentAdminRoute];

export default aiAgentRoutesList;
